import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { BatchTestClaimTypes } from "@/types";

export interface BatchTestClaimListState {
  batchTestClaimListResults: {
    results: Array<BatchTestClaimTypes.BatchTestClaim>;
    result_count: string;
  };
}

const DEFAULT_GET_TEST_CLAIM_LIST_STATE: BatchTestClaimListState = {
  batchTestClaimListResults: {
    results: [],
    result_count: "0",
  },
};

export default (state: BatchTestClaimListState = DEFAULT_GET_TEST_CLAIM_LIST_STATE, action: Action): BatchTestClaimListState => {
  if (action.type === ActionTypes.GET_BATCH_TRANSMISSION_TEST_CLAIM_LIST_RESULTS) {
    return {
      ...state,
      batchTestClaimListResults: action.payload,
    };
  } else {
    return state;
  }
};
